import PropTypes from "prop-types"

// material-ui
import { useTheme } from "@mui/material/styles"
import { Stack, Chip, Button, Divider, Box } from "@mui/material"

// project import
import DrawerHeaderStyled from "./DrawerHeaderStyled"
import Logo from "components/Logo"

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = ({ open }) => {
  const theme = useTheme()

  return (
    // only available in paid version
    <>
      <Logo />
      {/* <Divider sx={{ width: "100%", margin: "auto", marginBottom: "5em" }} /> */}
    </>
  )
}

DrawerHeader.propTypes = {
  open: PropTypes.bool,
}

export default DrawerHeader
